import { Stack } from '@mui/material';
import IDuInlineLogo from '../../../../assets/idu-inline.svg?react';
import { Typography } from '../../../primitives/typography/typography';
import { VersionData } from '../../../utils/app-version/version-data';

type AuthLayoutIduFooterProps = {
  showBrand?: boolean;
  showVersion?: boolean;
};

export const AuthLayoutIduFooter = ({
  showBrand = true,
  showVersion = false,
}: AuthLayoutIduFooterProps) => {
  return (
    <Stack sx={{ gap: 0.5, alignItems: 'center', textAlign: 'center' }}>
      {showBrand && <InlineLogoBranding />}
      {showVersion && <VersionData layout="compact" />}
    </Stack>
  );
};

const InlineLogoBranding = () => (
  <Stack direction="row" sx={{ gap: 0.75, alignItems: 'baseline' }}>
    <Typography.Caption sx={{ fontSize: '0.6875rem', lineHeight: 1 }}>
      Powered by
    </Typography.Caption>

    <Stack direction="row" sx={{ gap: 0.4, alignItems: 'baseline' }}>
      <IDuInlineLogo
        aria-label="iDU"
        style={{ display: 'block', height: 12, width: 'auto', color: '#1F2024' }}
      />
      <Typography.Caption
        sx={{
          color: 'text.primary',
          fontSize: '0.625rem',
          fontWeight: 700,
          lineHeight: 1,
          textTransform: 'uppercase',
        }}
      >
        Identification
      </Typography.Caption>
    </Stack>
  </Stack>
);
